/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateFolderInput = {
    id: string;
    name?: string | null | undefined;
    folderId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateFolderMutationVariables = {
    input: UpdateFolderInput;
};
export type updateFolderMutationResponse = {
    readonly updateFolder: {
        readonly folder: {
            readonly name: string | null;
            readonly folder: {
                readonly id: string;
                readonly name: string | null;
            } | null;
        } | null;
    } | null;
};
export type updateFolderMutation = {
    readonly response: updateFolderMutationResponse;
    readonly variables: updateFolderMutationVariables;
};



/*
mutation updateFolderMutation(
  $input: UpdateFolderInput!
) {
  updateFolder(input: $input) {
    folder {
      name
      folder {
        id
        name
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFolderInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Folder",
  "kind": "LinkedField",
  "name": "folder",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateFolderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFolderPayload",
        "kind": "LinkedField",
        "name": "updateFolder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Folder",
            "kind": "LinkedField",
            "name": "folder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateFolderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFolderPayload",
        "kind": "LinkedField",
        "name": "updateFolder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Folder",
            "kind": "LinkedField",
            "name": "folder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateFolderMutation",
    "operationKind": "mutation",
    "text": "mutation updateFolderMutation(\n  $input: UpdateFolderInput!\n) {\n  updateFolder(input: $input) {\n    folder {\n      name\n      folder {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a8bc2e4f5ed1afe7c8586749b1995099';
export default node;
